bowser = require("./node_modules/bowser/bowser.min.js");
require("./node_modules/howler/dist/howler.min.js");
$ = require("./node_modules/jquery/dist/jquery.min.js");
require("./node_modules/pixi.js/dist/pixi.min.js");
sprintf = require("./node_modules/sprintf-js/dist/sprintf.min.js").sprintf;
require("./node_modules/pixi-text-input/PIXI.TextInput.js");